'use client';

import { PropsWithChildren, useEffect } from 'react';

import { useAuth } from '@flipster/features/src/shared/auth/state';
import { useKYC } from '@flipster/features/src/shared/kyc';
import { useRouter } from '@flipster/i18n/routing';
import { alert } from '@flipster/ui/Alert';
import segment, { WalletEvent } from '@flipster/utils/segment';

const Template = ({ children }: PropsWithChildren) => {
  const router = useRouter();

  const { kycInfo } = useKYC();
  const { isLoggedIn, isValidKyc } = useAuth();

  const isShowKycAlert = isLoggedIn && !isValidKyc;

  useEffect(() => {
    const KycAlertKey = 'SHOW_KYC_ALERT';
    const isOpenedAlert = sessionStorage?.getItem(KycAlertKey) === 'true';
    if (isShowKycAlert && !isOpenedAlert) {
      alert.show({
        title: 'Identity verification',
        message: 'Required for deposit, withdrawal, and trading',
        confirmText: 'Verify now',
        onConfirm: () => {
          segment.track(WalletEvent.KycVerificationRequireClick, { kyc_level: kycInfo.currentKYCLevel });
          router.push('/user/kyc');
        },
        closeText: 'Dismiss',
        withClose: true,
      });
      sessionStorage?.setItem(KycAlertKey, 'true');
    }
  }, [isShowKycAlert, kycInfo.currentKYCLevel, router]);

  return children;
};

export default Template;
